import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { ApiError } from "../../shared/api/api-error";

export function QueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry(failureCount, error) {
              if (error instanceof ApiError && [401, 403, 404].includes(error.status)) return false;
              return failureCount < 1;
            },
            refetchOnWindowFocus: "always",
            staleTime: 20_000
          },
          mutations: {
            retry: false
          }
        }
      })
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
